import React from 'react';
import styled, { css } from 'styled-components';
import { hideAfterSm, hideBeforeSm } from "../../../theme/helpers/media";
import { addStyleIfPropTruly } from "../../../utils/styledComponents";
import CommentIcon from "../../Icon/Comment";
import ButtonMicro from "./ButtonMicro";
import colors from "../../../colors";
export var CommentButton = styled(ButtonMicro).attrs(function (_ref) {
  var comment = _ref.theme.comment;
  return {
    icon: true,
    children: React.createElement(CommentIcon, {
      width: comment === null || comment === void 0 ? void 0 : comment.btn.icon.width,
      height: comment === null || comment === void 0 ? void 0 : comment.btn.icon.height,
      color: comment === null || comment === void 0 ? void 0 : comment.btn.icon.defaultColor
    })
  };
}).withConfig({
  displayName: "CommentButton",
  componentId: "cqxssh-0"
})(["", " ", ";transition-property:background-color;&:before{content:'';position:absolute;top:3px;right:3px;display:block;width:5px;height:5px;border-radius:50%;background-color:", ";border:1px solid ", ";}", ""], function (_ref2) {
  var comment = _ref2.theme.comment;
  return css(["background-color:", ";&:hover{background-color:", ";}"], comment === null || comment === void 0 ? void 0 : comment.btn.bgColor, comment === null || comment === void 0 ? void 0 : comment.btn.hoverBgColor);
}, function (_ref3) {
  var isKomus = _ref3.isKomus;

  if (isKomus) {
    return css(["background-color:", ";&:hover{background-color:", ";}svg{& path{fill:", " !important;}}"], colors.light200, colors.dark100, colors.primaryMain);
  }
}, colors.watermelon, colors.white, addStyleIfPropTruly('isEmpty', "\n      &:before {\n        display: none;\n      }\n  "));
export var CommentButtonMobile = styled(CommentButton).withConfig({
  displayName: "CommentButton__CommentButtonMobile",
  componentId: "cqxssh-1"
})(["", ""], hideAfterSm);
export var CommentButtonDesktop = styled(CommentButton).withConfig({
  displayName: "CommentButton__CommentButtonDesktop",
  componentId: "cqxssh-2"
})(["", " ", " ", ""], function (_ref4) {
  var comment = _ref4.theme.comment;
  return css(["background-color:", ";svg{fill:", ";}"], comment === null || comment === void 0 ? void 0 : comment.btn.bgColorDesktop, comment === null || comment === void 0 ? void 0 : comment.btn.icon.defaultColorDesktop);
}, addStyleIfPropTruly('isEmpty', "display: none;"), hideBeforeSm);